module.exports = __webpack_public_path__ + "img/print.23cb71cf.svg";